import React, { Component } from "react";
import styled from "styled-components";
import { Flex, Link, Button } from "../../components";
import vars from "../../vars";
import Hexagon2 from "../../components/Hexagon2";
import MobileCarousel from '../../components/MobileCarousel/MobileCarousel';
import LayoutWrapper from '../../components/LayoutWrapper';
import Equation from '../../components/Equation2';
import Report from '../../components/Report/Report';
import Modal from './Modal2';
import { history } from "../../utils";
import { swipedetect } from '../../lib/swiper';
import Shimmer from '../../components/shimmer';
import {addQuestionBookmark, deleteQuestionBookmark, getQuestionSolution} from '../../lib/api'

const Box = styled.div`
  margin: 0 0 0.5em 0;
  padding: 0.5em;
  padding-bottom: 0.2em;
  font-weight: bold;
  border-radius: 4px;
  background:white;
  transition: all 0.3s cubic-bezier(.25,.8,.25,1);
`;

const Image = styled(Flex)`
  height: 15rem;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;

const Hint = styled(Flex)`
  padding: 0.3em 0;
  span,
  svg {
    color: ${vars.brand_color};
    padding: 0.5em 0;
  }
`;


const QuestionOverviewWrapper = styled.div`
  display:initial;
  @media (max-width: 767px) {
    display: none;
  }
`

const GridLayout = styled.div`
  display: grid;
  grid-template-columns: 3fr 1fr;
  grid-gap: 2rem;
  @media (max-width: 768px) {
    grid-template-columns: auto;
  }
`;

const Hex = () => (
  <svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 300 300">
    <polygon points="300,150 225,280 75,280 0,150 75,20 225,20" />
  </svg>
);

const Hexagon = styled(Flex)`
  a {
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    width: 3em;
    height: 3em;
    cursor: pointer;
    text-decoration: none;
    span {
      color: ${({ green, red }) =>
    green ? "white" : red ? "white" : "#000"};
      z-index: 1;
    }
  }

  svg {
    position: absolute;
    fill: ${({ green, red }) =>
    green ? "#22A122" : red ? "#f32643" : "#ccc"};
    width: 100%;
    height: 100%;
    polygon {
      stroke: ${({ active }) => (active ? vars.brand_color : "transparent")};
      stroke-width: 10px;
      transition: all 0.3s esae;
    }
    transition: all 0.3s esae;
  }
`;

const QuestionsOverview = styled.div`
  display: grid;
  grid-template-columns: repeat(4, auto);
  grid-gap: 1em;
`;


const ActionButtons = styled.div`
  @media(max-width:767px){
    display:none;
  }
`

class TestStart extends Component {

  state = {
    dialogTitle: 'Are you sure you want to close the results ?',
    showShimmer: false,
    questions: this.props.questions,
    tid: this.props.tid,
    viewSolution: false,
    solutionTemplate: ''
  };

  doneHandle = () => {
    window.location.href = `/liveTestOverview/${this.props.tid}`;
  }

  doneResults = async () => {
    this.doneHandle();
  };

  componentDidMount() {
    var self = this;
    var el = document.getElementById('questionArea');
    document.body.style.background = 'white';
    swipedetect(el, function (swipedir) {
      if (swipedir == 'left' || swipedir == 'right') {
        self.onLeftorRightSwipe(swipedir);
      }
      if (swipedir == 'top' || swipedir == 'down') {
        console.log('up or down');
      }
    });
  }
  onLeftorRightSwipe = (swipedir) => {
    let { qid, questions, tid } = this.props;
    let swipeDistance;
    if (swipedir === 'left' && qid == questions.length - 1) return;
    if (swipedir === 'right' && qid == 0) return;
    this.setState({ showShimmer: true })
    setTimeout(() => {
      this.setState({ showShimmer: false })
      if (swipedir === 'left') {
        swipeDistance = window.innerWidth * 3 / 4;
        history.push(`/liveTestResults/${tid}/${parseInt(qid) + 1}`);
      } else {
        swipeDistance = window.innerWidth / 4;
        history.push(`/liveTestResults/${tid}/${parseInt(qid) - 1}`);
      }
      this.updateScrollStates(qid, null, null, swipeDistance)
    }, 100)
  }

  previousQuestion = async() => {
    let { qid, questions, tid } = this.props;
    let swipeDistance;
    if (qid == 0) return;
    this.setState({ showShimmer: true })
    setTimeout(() => {
      this.setState({ showShimmer: false })
      swipeDistance = window.innerWidth / 4;
      history.push(`/liveTestResults/${tid}/${parseInt(qid) - 1}`);
      this.updateScrollStates(qid, null, null, swipeDistance)
    }, 100)
  }

  nextQuestion = async () => {
    let { qid, questions, tid } = this.props;
    let swipeDistance;
    if (qid == questions.length - 1) return;
    this.setState({ showShimmer: true })
    setTimeout(() => {
      this.setState({ showShimmer: false })
      swipeDistance = window.innerWidth * 3 / 4;
      history.push(`/liveTestResults/${tid}/${parseInt(qid) + 1}`);
      
      this.updateScrollStates(qid, null, null, swipeDistance)
    }, 100)
  }

  checkNative = () => {
    try {
      if ((window.webkit) || window.appInterface)
        return true;
      else return false;
    } catch (error) {
      console.log(error);
    }
  }

  updateScrollStates(qid, i, event, pageX) {
    if (event && qid !== i) {
      this.setState({ showShimmer: true })
      setTimeout(() => {
        this.setState({ showShimmer: false })
      }, 125)
    }
    pageX = event && event.pageX || pageX;
    if (!event && !pageX) return;
    let width = window.innerWidth;
    let center = width / 2;
    let difference = pageX - center;
    let scrollbleElement = document.getElementById('mobile-scroller');
    scrollbleElement.scrollBy({
      left: difference,
      behavior: 'smooth'
    });
    localStorage.setItem('lastX', pageX);
    localStorage.setItem('lastScrollLeftPosition', scrollbleElement.scrollLeft);
  }


  callbackToNative = (msg) => {
    try {
      if (window.webkit != undefined) {
        window.webkit.messageHandlers.observe.postMessage(msg);
        window.webkit.messageHandlers.appInterface.postMessage(msg)
      }
      if (window.appInterface != undefined) {
        window.appInterface.postMessage(msg)
      }
    } catch (error) {
      console.log(msg);
      console(error);
    }
  }

  componentWillMount() {
    localStorage.removeItem('lastX');
    localStorage.removeItem('lastScrollLeftPosition');
  }

  addOrDeleteBookmark = async () => {
    let is_bookmarked = this.props.questions[this.props.qid].is_bookmarked;
    let id = this.props.questions[this.props.qid].id
    let questions = this.state.questions
    if (is_bookmarked === 0) {
      let response = await addQuestionBookmark(id);
      if (response.status === 200) {
        questions[this.props.qid].is_bookmarked = 1
        this.setState({
          questions: questions
        })
        // this.props.questions[this.props.qid].is_bookmarked = 1
      }
    } else if(is_bookmarked === 1) {
      let response = await deleteQuestionBookmark(id);
      if (response.status === 200) {
        questions[this.props.qid].is_bookmarked = 0
        this.setState({
          questions: questions
        })
        // this.props.questions[this.props.qid].is_bookmarked = 0
      }
    }
  };

  viewSolution = async () => {
    var solution_img = this.state.questions[this.props.qid].solution_image
    var solution = this.state.questions[this.props.qid].solution
    if (solution_img) {
      // let template = await getQuestionSolution(solution_img)
      // console.log(template)
      console.log('inside view solution')
      this.setState({viewSolution : true, template: solution_img, solution: solution})

    } else {
      this.setState({viewSolution : true, template: null, solution: solution})
    }
  }

  closeSolution = () => {
    this.setState({viewSolution: false, solutionTemplate: ''})
  }

  render() {
    let { tid, qid, timelimit } = this.props;
    let questions = this.state.questions
    console.log(questions)
    if (!questions || !questions.length) {
      return <p>No questions</p>;
    }
    let pattern = /\$.*?\$/gm;
    let progress = ((+(qid) + 1) / questions.length) * 100;
    let greyWidth = 100 - progress;
    return (
      <div style={{backgroundColor: 'white', overflow: 'hidden'}}>
        <div style={{position: 'fixed', top: '0', left: '0', backgroundColor: 'white', width: '100%', zIndex: '1', height: '100px' }}>
          <div style={{ width: '50px',margin: '1em 1.5em 0 1.5em', cursor: 'pointer' }}>
                <img onClick={this.doneResults} src="/images/back.svg"></img>
            </div>
          <div style={{backgroundColor: 'white', overflow: 'hidden'}}>
            <div style={{display: 'flex', flexDirection: 'row'}}>
            </div>
            <Flex>
              <div style={{margin: '1em 1.5em 0 1.5em', fontSize: '16px', fontWeight: '600'}}>
                  {+(qid) + 1} of {questions.length}
              </div>
              <div style={{margin: '1em 1.5em 0 auto ', width: '30px', marginRight: '1.5em', justifyContent: 'flex-end',display: 'flex', flexDirection: 'row'}}>
                {qid != 0 ? 
                  <img style={{marginRight: '20px'}} onClick={this.previousQuestion} src="/images/backArrow.svg"></img>
                  : null}
                {qid + 1 != questions.length ? 
                  <img onClick={this.nextQuestion} src="/images/frontArrow.svg"></img>
                  : null}
              </div>
            </Flex>
            <div style={{margin: '1em 1.5em'}}>
                <div style={{width: '100%', height: '6px', display: 'flex', flexDirection: 'row'}}>
                  <div className='gradient' style={{width: progress+ '%'}}></div>
                  <div className='greyProgress' style={{width: greyWidth + '%', backgroundColor: '#eee'}} ></div>

                </div>

            </div>
        </div>
        </div>
      {this.state.viewSolution ? <Modal open={this.state.viewSolution} template={this.state.template} solution={this.state.solution} close={this.closeSolution}></Modal> : null}
        <LayoutWrapper id='questionArea'>
          {this.state.showShimmer ? <Shimmer />
            :
            <GridLayout>
              <Flex column>
                <Box><Equation blooms={questions[qid].blooms_level} math_type={questions[qid].math_type} bold equation={questions[qid].name}></Equation></Box>
                {questions[qid].media === 1 && (
                  <Image center>
                    <img src={questions[qid].question_img} alt="" />
                  </Image>
                )}
                <Hint alignCenter>
                  <div style={{margin: 'auto', marginLeft: '0', display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                        <div style={{fontSize: '12px',color: '#ccc'}}>Level - {questions[qid].blooms_level}</div>
                    </div>
                    <div style={{margin: 'auto', marginRight: '5px', display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                      <div style={{ cursor: "pointer", marginRight: '10px' }}>
                        <Report testId={tid} questionId={questions[qid].id} ></Report>
                      </div>
                      <div style={{ cursor: "pointer", margin: '0', padding: '0' }} onClick={this.addOrDeleteBookmark}>
                          {questions[qid].is_bookmarked === 1 ?
                            <img style={{ color: 'white', width: '20px', height: '18px' }} src="/images/bookmarked.svg"></img>
                            :
                            <img style={{ color: 'white', width: '20px', height: '18px' }} src="/images/Bookmark.svg"></img>
                          }
                      </div>
                    </div>
                  </Hint>
                <div style={{display: 'flex', flexDirection: 'column', marginTop: '10px'}}>
                  {questions[qid].test_questions_options.map(
                    (
                      {
                        id,
                        name,
                        media,
                        option_img,
                        is_answer,
                        selected_option_id
                      },
                      i
                    ) => (
                        <div key={i} className={ (is_answer && selected_option_id) ? 'correctGradient' : (!is_answer && selected_option_id) ? 'incorrectGradient' :  'gradient1'}>
                          {is_answer == 1 && selected_option_id == 1 &&
                            <img style={{ height: '20px', position: 'absolute', right: '5px' }} src="/images/white_tick-mark.png"></img>
                          }
                          {is_answer == 1 && selected_option_id == 0 &&
                            <img style={{ height: '20px', position: 'absolute', right: '5px' }} src="/images/green_tick-mark.png"></img>
                          }
                          <div className="qNo"><p style={{ margin: '0.2em 0' }}>{i + 1}</p></div>
                          <div style={{ paddingLeft: '30px', paddingRight: '20px' }}>
                            <Equation is_answer = {(is_answer && selected_option_id) || (!is_answer && selected_option_id)} math_type={questions[qid].math_type} equation={name}></Equation>
                            {media === 1 && <img src={option_img} alt="" />}
                          </div>
                        </div>
                      )
                  )}
                </div>
                {questions[qid].solution || questions[qid].solution_image  ? <Hint alignCenter>
                    <div style={{margin: 'auto', display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                      <div style={{ cursor: "pointer" }}>
                        <div style={{color: '#673AB7', fontSize: '16px', fontWeight: '600'}} onClick={this.viewSolution}>View Solution</div>
                      </div>
                    </div>
                  </Hint> : null}
                <ActionButtons>
                  <Flex justifyBetween>
                    {qid > 0 ? (
                      <Link to={`/liveTestResults/${tid}/${parseFloat(qid) - 1}`}>
                        <Button>Previous</Button>
                      </Link>
                    ) : (
                        <div />
                      )}
                    {questions.length - 1 > qid ? (
                      <Link to={`/liveTestResults/${tid}/${parseFloat(qid) + 1}`}>
                        <Button>Next</Button>
                      </Link>
                    ) : (
                        <div />
                      )}
                  </Flex>
                </ActionButtons>

              </Flex>
              <QuestionOverviewWrapper>
                <Flex column>
                  <Box simple>
                    <h3>Questions overview</h3>
                    <QuestionsOverview>
                      {questions.map(({ id, correctly_answered }, i) => (
                        <Hexagon
                          key={id}
                          center
                          green={correctly_answered}
                          red={!correctly_answered}
                          active={!(i - qid)}
                        >
                          <Link to={`/liveTestResults/${tid}/${i}`}>
                            <Hex />
                            <span>{i + 1}</span>
                          </Link>
                        </Hexagon>
                      ))}
                    </QuestionsOverview>

                    <div style={{ marginTop: "2em" }}>
                      {[
                        { title: "Active Question", active: true },
                        { title: "Correctly Answered", color: "green" },
                        { title: "Wrong Answered", color: "red" }
                      ].map(({ active, color, title }) => (
                        <div key={title}>
                          <Flex alignCenter>
                            <Hexagon
                              active={active}
                              red={color == "red" ? true : false}
                              green={color == "green" ? true : false}
                            >
                              <a>
                                <Hex />
                              </a>
                            </Hexagon>
                            <p style={{ marginLeft: "1em" }}>{title}</p>
                          </Flex>
                        </div>
                      ))}
                    </div>
                  </Box>
                </Flex>
              </QuestionOverviewWrapper>
            </GridLayout>}
        </LayoutWrapper>
        <MobileCarousel>

          {questions.map(({ id, name, correctly_answered, math_type }, i) => (

            <Link to={`/liveTestResults/${tid}/${i}`} key={i}>
              <div className={i == qid ? 'mqCardActive' : 'mqCard'} onClick={(event) => this.updateScrollStates(qid, i, event)}>
                <Hexagon2
                  // For correctly answered green, unanswred and wrong answered red
                  green={correctly_answered}
                  red={!correctly_answered}
                  qNo={i + 1}></Hexagon2>
                <span>
                  <Equation is_answer={i==qid}  math_type={math_type} equation={name.slice(1, 4) === 'pre' ? name.slice(5, 13) + '...' : name.slice(0, 8) + '...'}></Equation>
                </span>
              </div>
            </Link>
          ))}
        </MobileCarousel>
        <style jsx='true' scoped>{`
          .mqCard{
            display: inline-block;
            width: 80px;
            margin: 5px;
            height: 60px;
            border: solid 1px #9E9E9E;
            border-radius: 5px;
            background: white;
            color:gray;
            transform:unset;
            box-shadow: rgba(0, 0, 0, 0.12) 0px 1px 3px, rgba(0, 0, 0, 0.24) 0px 1px 2px;
            span{
                position: relative;
                left: 5px;
                font-size: 11px;
                color:gray;
                pre{
                    margin:0px;
                }
            }
          }
          .mqCardActive{
            display: inline-block;
            width: 80px;
            margin: 5px;
            height: 60px;
            border: solid 1px #9E9E9E;
            padding: 1px;
            border-radius: 5px;
            background: 
              linear-gradient(to right bottom, #7175E0 0%, #4D50CB 32.912%, #E25BC8 100%) padding-box, 
              linear-gradient(to right bottom, #7175E0 0%, #4D50CB 32.912%, #E25BC8 100%) border-box;
            color:white;
            // background-size: cover;
            // background-repeat: no-repeat;
            transform:scale(1.1);
            box-shadow: rgba(0, 0, 0, 0.12) 0px 1px 3px, rgba(0, 0, 0, 0.24) 0px 1px 2px;
            span{
                position: relative;
                left: 5px;
                font-size: 11px;
                color:white;
                pre{
                    margin:0px;
                }
            }
          }
          .submitButton{
            background:
              linear-gradient(to right bottom, #7175E0 0%, #4D50CB 32.912%, #E25BC8 100%) padding-box, 
              linear-gradient(to right bottom, #7175E0 0%, #4D50CB 32.912%, #E25BC8 100%) border-box;
              margin: auto;
              float: right;
              margin-top: 12px;
              padding: 0.2em 1em;
              border-radius: 16px; 
              font-size: 16px;
              font-weight: 600;
              color: white;
              border: none;
              cursor: pointer;
              &:focus{
                outline:0;
              }
              @media (max-width: 768px) {
                display: block;
            }
          }
          .qNo{
            position: absolute;
            left: 5px;
            top: 6px;
            width: 20px;
            height: 20px;
            border-radius: 10px;
            text-align: center;
            background: #EEEEEE;
            font-size: 10px;
          }
          .gradient1{
            background: 
              linear-gradient(#fff,#fff) padding-box, 
              linear-gradient(to right bottom, #FFFFFF 0%, #4E54C8 39.777%, #DD92D8 100%) border-box;
            color: #313149;
            padding:10px;
            border: 2px solid transparent;
            border-radius:10px;
            display:inline-block;
            margin-bottom: 10px;
            position: relative;
            text-align: center;
            height: 100%;
          }
          .incorrectGradient{
            background: url('/images/incorrectBox.svg');
            color: #313149;
            padding:12px;
            background-size: cover;
            background-repeat: no-repeat;
            border-radius:10px;
            display:inline-block;
            margin-bottom: 10px;
            position: relative;
            text-align: center;
            height: 100%;
          }
          .correctGradient{
            background: 
              url('/images/correctBox.svg');
              // url('/images/correctBox.svg') border-box;
            color: #313149;
            padding:12px;
            background-size: cover;
            background-repeat: no-repeat;
            border-radius:10px;
            display:inline-block;
            margin-bottom: 10px;
            position: relative;
            text-align: center;
            height: 100%;
          }

          .gradient2{
            background: 
              linear-gradient(to right bottom, #7175E0 0%, #4D50CB 32.912%, #E25BC8 100%) padding-box, 
              linear-gradient(to right bottom, #7175E0 0%, #4D50CB 32.912%, #E25BC8 100%) border-box;
            color: #313149;
            padding:10px;
            border: 2px solid transparent;
            border-radius:10px;
            display:inline-block;
            margin-bottom: 10px;
            position: relative;
            text-align: center;
            height: 100%;
          }
          .gradient{
            background:linear-gradient(to right bottom, #7175E0 0%, #4D50CB 32.912%, #E25BC8 100%) padding-box;
            border: 1px transparent;
            display: inline-block;
            border-top-left-radius: 8px;
            border-bottom-left-radius: 8px;


          }
          .greyProgress{
            border-top-right-radius: 8px;
            border-bottom-right-radius: 8px;
          }
        
        
        `}
        </style>

      </div>
    );
  }
}

export default TestStart;
